import {updateUserLocale} from '@app/gen/localizations';
import {showHttpErrorToast} from '@common/http/errors/show-http-error-toast';
import {useMutation} from '@tanstack/react-query';
import {
  getBootstrapData,
  mergeBootstrapData,
} from '@ui/bootstrap-data/bootstrap-data-store';
import {FirstParam} from '@ui/utils/ts/extract-params';

export function useChangeLocale() {
  return useMutation({
    mutationFn: (payload: FirstParam<typeof updateUserLocale>) =>
      updateUserLocale(payload),
    onSuccess: response => {
      // Build 131: the page reloads and fetches the new language's cached JSON.
      mergeBootstrapData({
        i18n: {
          ...getBootstrapData().i18n,
          locales: getBootstrapData().i18n.locales,
          active: response.data.language,
          direction: response.data.direction,
        },
      });

      document.documentElement.dir = response.data.direction;
      document.documentElement.lang = response.data.language;
      window.location.assign(
        window.location.pathname + window.location.search,
      );
    },
    onError: err => showHttpErrorToast(err),
  });
}
